import React from "react";
import propertiesSectionData from "../data/propertiesSectionData";
import { Link } from "react-router-dom";
import { useTranslation } from 'react-i18next';
import UseScrollAnimation from "../../hooks/UseScrollAnimation";
export default function PropertiesSection() {
  const { t } = useTranslation();
  UseScrollAnimation();

  const uniqueCountries = [...new Set(propertiesSectionData.map((el) => el.countries))];

  const showData = uniqueCountries.map((country, index) => {
    const propertiesNumber = propertiesSectionData.filter(
      (property) => property.countries === country
    ).length;

    return (
      <Link
        key={index}
        to={`propertiesPlaces/${encodeURIComponent(country)}`}
        className="w-165-px g-5rem js-scroll fade-top p-respons w-[210px] px-5 py-[1rem] flex items-center gap-4 border border-[#D9D9D9] rounded-[8px]"
      >
        <div>
          <img
            className="w-respons w-[50px] h-[50px] rounded-full"
            src={propertiesSectionData.find((el) => el.countries === country)?.image}
            alt=""
          />
        </div>
        <div>
          <div className="text-[#0B2C3D] font-bold capitalize">{t(`${country}`)}</div>
          <div className="flex items-center gap-[3px]">
            <span>{propertiesNumber}</span>
            {t("Properties")}
          </div>
        </div>
      </Link>
    );
  });

  return (
    <section className="relative py-[40px]">
      <div className="main-title">
        <div className="js-scroll fade-btm secund">{t("Explore properties")}</div>
      </div>
      <div className="container py-[20px] flex-col gap-[20px]">
        <div className="just-center flex flex-wrap items-center justify-center gap-[10px]">
          {showData}
        </div>
      </div>
    </section>
  );
}